import React, { useEffect, useRef, useState } from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { LazyImg } from '@ifeng-fe/ui_pc_lazyLoad';
import { Player } from 'ThreeTerminal_mobile_dynamic';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

/* eslint-disable */
const PC = allData.pc;
/* eslint-disable */

const styles = require(PC ? '../../../../pc/index/layout/block.css' : './index.css').default;

const SlideArrow = errorBoundary(props => {
    const { slide } = props;

    if (!PC) return null;

    return (
        <div className={styles.SlideArrows}>
            <img src={require('./assets/arr_l.png')} alt="" onClick={() => slide.current.slickPrev()} />
            <img src={require('./assets/arr_r.png')} alt="" onClick={() => slide.current.slickNext()} />
        </div>
    );
});

const Flow = errorBoundary(({ content }) => {
    return (
        <div className={styles.Flow}>
            <div className={styles.blockTitle}>
                <LazyImg src={require('./assets/flow_title.png')} alt="" />
            </div>
            <div className={styles.table}>
                <div className={styles.title}>
                    <div>时间</div>
                    <div>内容</div>
                </div>
                <div className={styles.content}>
                    {content.map((item, index) => (
                        <div key={index} className={styles.items}>
                            <div>{item.time}</div>
                            <div>{item.content}</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
});

const News = errorBoundary(({ content }) => {
    return (
        <div className={styles.News}>
            <div className={styles.blockTitle}>
                <LazyImg src={require('./assets/news_title.png')} alt="" />
            </div>
            <div className={styles.content}>
                {content.map((item, index) => (
                    <div key={index} className={styles.items} onClick={() => (location.href = item.url)}>
                        <div className={styles.pic}>
                            <LazyImg src={item.thumbnail} alt="" />
                        </div>
                        <div className={styles.text}>
                            <div>{item.title}</div>
                            <div>{item.newsTime.slice(11, 16)}</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
});

const SlideBox = {
    Dots: errorBoundary(({ content, SP, active }) => {
        const arr = new Array(Math.ceil(content.length / SP)).fill(0);

        return (
            <div className={styles.slideDots}>
                {arr.map((item, index) => (
                    <div key={index} className={`${styles.dot} ${index === active ? styles.active : null}`} />
                ))}
            </div>
        );
    }),
    SlideData: ({ content, SP, SlideItem }) => {
        let data = content.slice();
        let result = [];

        for (let index = 0; index < data.length; index += SP) {
            result.push(<SlideItem key={index} content={data.slice(index, index + SP)} />);
        }

        return result;
    },
};

const Stars = errorBoundary(({ content }) => {
    const [active, setActive] = useState(0);
    const slide = useRef(null);
    const SP = PC ? 12 : 9;

    const slideSettings = {
        dots: false,
        infinite: true,
        slidesToScroll: 1,
        arrows: false,
        afterChange: index => setActive(index),
    };

    const SlideItem = errorBoundary(({ content }) => {
        return (
            <div className={styles.slideContent}>
                {content.map((item, index) => (
                    <div key={index} className={styles.items} onClick={() => (location.href = item.videoPlayUrl)}>
                        <div className={styles.pic}>
                            <LazyImg src={item.posterUrl || item.thumbnail} alt="" />
                            <LazyImg src={require('./assets/play_s.png')} alt="" />
                        </div>
                        <div className={styles.text}>{item.title}</div>
                    </div>
                ))}
            </div>
        );
    });

    return (
        <div className={styles.Stars}>
            <div className={styles.blockTitle}>
                <LazyImg src={require('./assets/star_title.png')} alt="" />
            </div>
            <SlideArrow slide={slide} />
            <div className={styles.content}>
                <Slider ref={slide} {...slideSettings}>
                    {SlideBox.SlideData({ content, SP, SlideItem })}
                </Slider>
                <SlideBox.Dots content={content} SP={SP} active={active} />
            </div>
        </div>
    );
});

const Pics = errorBoundary(({ content }) => {
    const [active, setActive] = useState(0);
    const slide = useRef(null);
    const SP = 1;

    const slideSettings = {
        dots: false,
        infinite: true,
        slidesToScroll: 1,
        centerMode: !PC,
        slidesToShow: 1,
        arrows: false,
        className: styles.picFix,
        centerPadding: '5%',
        afterChange: index => setActive(index),
    };

    const SlideItem = errorBoundary(({ content }) => {
        let pic = content[0];

        return (
            <div className={styles.slideContent}>
                <img src={pic.thumbnail} alt="" onClick={() => (location.href = pic.url)} />
                <img
                    className={styles.scale}
                    src={require('./assets/scale.png')}
                    onClick={() => (location.href = pic.url)}
                    alt=""
                />
            </div>
        );
    });

    return (
        <div className={styles.Pics}>
            <div className={styles.blockTitle}>
                <LazyImg src={require('./assets/pics_title.png')} alt="" />
            </div>
            <SlideArrow slide={slide} />
            <div className={styles.content}>
                <Slider ref={slide} {...slideSettings}>
                    {SlideBox.SlideData({ content, SP, SlideItem })}
                </Slider>
                <SlideBox.Dots content={content} SP={SP} active={active} />
            </div>
        </div>
    );
});

const Live = errorBoundary(({ content }) => {
    const [active, setActive] = useState(0);
    const slide = useRef(null);
    const SP = !PC ? 3 : 5;

    const slideSettings = {
        dots: false,
        infinite: true,
        slidesToScroll: 1,
        arrows: false,
        afterChange: index => setActive(index),
    };

    const MainVideo = errorBoundary(({ content }) => {
        const isLive = content[0].type === 'live';
        const liveid = isLive ? content[0].liveId : null;
        const LiveURL = PC
            ? `https://finance.ifeng.com/loc/special/zhiboplayer/pc?liveid=${liveid}`
            : `https://finance.ifeng.com/loc/special/zhiboplayer/mobileIframe?liveid=${liveid}`;

        return (
            <div className={styles.mainVideo}>
                <div className={styles.video}>
                    <div className={styles.player}>
                        {!isLive ? (
                            <Player playermsg={{}} videoConfig={content[0]} />
                        ) : (
                            <div className={styles.live}>
                                <iframe width="100%" height="100%" src={LiveURL} frameBorder="0" />
                            </div>
                        )}
                    </div>
                </div>
                <div className={styles.btn} onClick={() => (location.href = content[0].url)}>
                    <img src={require('./assets/video_c.png')} alt="" />
                    <span>点击观看直播</span>
                </div>
            </div>
        );
    });

    const SlideItem = errorBoundary(({ content }) => {
        return (
            <div className={styles.slideContent}>
                {content.map((item, index) => (
                    <div
                        key={index}
                        className={styles.items}
                        onClick={() => (location.href = item.videoPlayUrl || item.url)}>
                        <div className={styles.pic}>
                            <LazyImg src={item.posterUrl || item.thumbnail} alt="" />
                            <LazyImg src={require('./assets/play_s.png')} alt="" />
                        </div>
                        <div className={styles.text}>{item.title}</div>
                    </div>
                ))}
            </div>
        );
    });

    return (
        <div className={styles.Live}>
            <div className={styles.blockTitle}>
                <LazyImg src={require('./assets/live_title.png')} alt="" />
            </div>
            <SlideArrow slide={slide} />
            <div className={styles.content}>
                <MainVideo content={content} />
                <Slider ref={slide} {...slideSettings}>
                    {SlideBox.SlideData({ content, SP, SlideItem })}
                </Slider>
                <SlideBox.Dots content={content} SP={SP} active={active} />
            </div>
        </div>
    );
});

const Talk = errorBoundary(({ content }) => {
    return (
        <div className={styles.Talk}>
            {content.map((item, index) => (
                <div key={index} className={styles.items} onClick={() => (location.href = item.url)}>
                    <div className={styles.pic}>
                        <LazyImg src={item.thumbnail} alt="" />
                    </div>
                    <div className={styles.text}>
                        <div>{item.title}</div>
                        <div>{item.newsTime?.slice(11, 16)}</div>
                    </div>
                </div>
            ))}
        </div>
    );
});

export default {
    Flow,
    News,
    Stars,
    Live,
    Pics,
    Talk,
};
